import { fromJS } from 'immutable';

import {
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  PROFILE_UPDATED_ERROR,
  REQUEST_API_KEY_SUCCEED,
  REQUEST_API_KEY_ERROR,
  TOGGLE_MEMBER_SUCCEED,
  TOGGLE_MEMBER_ERROR,
  ADD_MEMBER_SUCCEED,
  ADD_MEMBER_ERROR,
  UPDATE_MEMBER_SUCCEED,
  UPDATE_MEMBER_ERROR,
  UPLOAD_LOGO_SUCCEED,
  UPLOAD_LOGO_ERROR,
  PASSWORD_UPDATED_ERROR,
  SET_LOADING,
} from './constants';
import { AGENT_MEMBERS_LOADED } from '../Profile/constants';

// The initial state of the App
export const initialState = fromJS({
  loading: false,
  invalid: false,
  user: {
    preferences: [],
  },
  members: [],
  errors: {},
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_USER_SUCCESS:
    case UPLOAD_LOGO_SUCCEED:
      return state
        .set('user', action.user)
        .set('invalid', false)
        .set('loading', false);
    case LOAD_USER_ERROR:
      return state.set('invalid', true).set('loading', false);
    case REQUEST_API_KEY_SUCCEED:
      return state
        .set('user', { ...state.get('user'), apiKey: action.apiKey })
        .set('errors', {})
        .set('loading', false);
    case PASSWORD_UPDATED_ERROR:
    case PROFILE_UPDATED_ERROR:
    case UPLOAD_LOGO_ERROR:
    case ADD_MEMBER_ERROR:
    case UPDATE_MEMBER_ERROR:
    case TOGGLE_MEMBER_ERROR:
    case REQUEST_API_KEY_ERROR:
      return state
        .set('errors', { ...state.get('errors'), ...action.errors })
        .set('loading', false);
    case ADD_MEMBER_SUCCEED:
      var members = state.get('members');
      members.push(action.agent);
      return state
        .set('members', { members })
        .set('errors', {})
        .set('loading', false);
    case UPDATE_MEMBER_SUCCEED:
    case TOGGLE_MEMBER_SUCCEED:
      var members = [...state.get('members')];
      var memberIdx = members.findIndex(
        currentMember => currentMember.code === action.agent.code,
      );
      members[memberIdx] = action.agent;
      return state
        .set('members', members)
        .set('errors', {})
        .set('loading', false);
    case AGENT_MEMBERS_LOADED:
      return state
        .set('members', action.members)
        .set('errors', {})
        .set('loading', false);
    case SET_LOADING:
      return state.set('loading', action.loading);
    default:
      return state;
  }
}

export default appReducer;
